import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { SharedModule } from '@shared/shared.module';
import { Store, Select } from '@ngxs/store';
import { ENQUIRE_ENDT_NARRATION } from '@store/sat-motor/sat-motor.action';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-endorsement-narration',
  standalone: true,
  imports: [
    SharedModule
  ],
  templateUrl: './endorsement-narration.component.html',
  styleUrl: './endorsement-narration.component.scss'
})
export class EndorsementNarrationComponent implements OnInit {
  @Input() endtType: string;
  @Input() endtNarration: string;
  @Input() parentForm: FormGroup;
  @Input() narrationForm: FormGroup;
  safeEndtNarration: SafeHtml;
  narrationHTML: HTMLParagraphElement[];
  characterCount: number = 0;

  constructor(
    private fb: FormBuilder,
    public sanitizier: DomSanitizer,
    public store: Store,
  ) {}

  ngOnInit() {
    this.narrationForm = this.fb.group({
      txtNarration: [""],
    });

    this.safeEndtNarration = this.sanitizier.bypassSecurityTrustHtml(this.endtNarration);

    this.narrationHTML = [];

    let parser = new DOMParser();
    let parserHtml = parser.parseFromString(this.endtNarration, "text/html");
    let pTags = parserHtml.getElementsByTagName("p");
    Array.from(pTags).forEach(p => {
      this.narrationHTML.push(p);
    });

    this.parentForm?.addControl("narrationForm", this.narrationForm);
  }

  isUserInput(item: HTMLParagraphElement) {
    return item.innerHTML.includes("User to input the narration");
  }

  onKeyUp(event: any) {
    this.characterCount = event.target.value.length;
  }

  get txtNarration() {
    return this.narrationForm.controls["txtNarration"];
  }

}
